import React from 'react'
import PropTypes from 'prop-types'

const classNames = require('classnames')

const PaginationControls = ({
  currentPage,
  totalPages,
  handlePageChange,
  maxDisplayedPages,
}) => {
  return (<div className="cls-lb-pagination">
    <button
      onClick={() => handlePageChange(currentPage - 1)}
      disabled={currentPage === 1}
      className='cls-lb-page-button'
    >
      {`← ${window.I18n.t('buttons.previous')}`}
    </button>

    {totalPages <= maxDisplayedPages ? (
      // Show all pages if 5 or fewer
      Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
        <button
          key={page}
          onClick={() => handlePageChange(page)}
          className={classNames(
            {'cls-lb-page-button': true,
              'cls-lb-page-button-active': currentPage === page})}
        >
          {page}
        </button>
      ))
    ) : (
      // Show first, current and last page
      <>
        <button
          onClick={() => handlePageChange(1)}
          className={classNames(
            {'cls-lb-page-button': true,
              'cls-lb-page-button-active': currentPage === 1})}
        >
          1
        </button>

        {currentPage > 2 && <span className="cls-page-info">...</span>}

        {currentPage >= 2 && currentPage < totalPages && (
          <button
            onClick={() => handlePageChange(currentPage)}
            className='cls-lb-page-button-active'
          >
            {currentPage}
          </button>
        )}

        {currentPage < totalPages - 1 && <span className="cls-page-info">...</span>}

        <button
          onClick={() => handlePageChange(totalPages)}
          className={classNames(
            {'cls-lb-page-button': true,
              'cls-lb-page-button-active': currentPage === totalPages})}
        >
          {totalPages}
        </button>
      </>
    )}

    <button
      onClick={() => handlePageChange(currentPage + 1)}
      disabled={currentPage === totalPages}
      className='cls-lb-page-button'
    >
      {`${window.I18n.t('buttons.next')} →`}
    </button>
  </div>)
}

PaginationControls.propTypes = {
  currentPage: PropTypes.number.isRequired,
  totalPages: PropTypes.number.isRequired,
  maxDisplayedPages: PropTypes.number.isRequired,
  handlePageChange: PropTypes.func.isRequired,
}

export default PaginationControls
